import { Form, Input, InputNumber, Select, Space } from "antd";
import WrappingModal from "../../../../../components/Modals/WrappingModal";

interface Props {
  form: any;
  isEditing: boolean;
  isModalOpen: boolean;
  handleOk: (values: any) => void;
  handleCancel: () => void;
  initialValues?: any;
  loading: boolean;
  countries: any[];
}

const FormModal = ({
  form,
  isEditing,
  isModalOpen,
  handleOk,
  handleCancel,
  initialValues,
  loading,
  countries,
}: Props) => {
  return (
    <WrappingModal
      form={form}
      handleCancel={handleCancel}
      loading={loading}
      isModalOpen={isModalOpen}
      title={isEditing ? "تعديل مدينة" : "إضافة مدينة"}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
        onFinish={handleOk}
      >
        <Space direction="vertical" className="w-full" size="large">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {isEditing && (
              <Form.Item name="CityID" label="كود المدينة">
                <InputNumber
                  placeholder="كود المدينة"
                  className="w-full"
                  disabled
                />
              </Form.Item>
            )}
            <Form.Item name="CityName" label="اسم المدينة">
              <Input placeholder="اسم المدينة" />
            </Form.Item>
            <Form.Item name="CountryID" label=" البلد">
              <Select
                placeholder=" البلد"
                options={countries.map((country: any) => ({
                  label: country.CountryName,
                  value: country.CountryID,
                }))}
              />
            </Form.Item>
          </div>
        </Space>
      </Form>
    </WrappingModal>
  );
};

export default FormModal;
